export const FETCH_ALLASSIGNBOOK_REQUEST = 'FETCH_ALLASSIGNBOOK_REQUEST'
export const FETCH_ALLASSIGNBOOK_SUCCESS = 'FETCH_ALLASSIGNBOOK_SUCCESS'
export const FETCH_ALLASSIGNBOOK_FALIURE = 'FETCH_ALLASSIGNBOOK_FALIURE'
